<template>
  <div class="page">
    <div class="main">
      <!-- <van-cell title="报名校区" title-class="tctil" required is-link @click="selectCampus">
        <template>
          <div v-if="campus">
            <div class="vu van-ellipsis">{{ campus.name }}</div>
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>

      <van-cell title="学员" title-class="tctil" required is-link @click="selectStudent">
        <template>
          <div v-if="student && student.id" style="color: var(--g8)">
            {{ student.name }}
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>

      <van-cell title="调出班级" title-class="tctil" required is-link @click="chooseOutClass">
        <template>
          <div v-if="outClass">
            <div class="vu van-ellipsis">{{ outClass.className }}</div>
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell> -->

      <van-cell title="调入班级" title-class="tctil" required is-link @click="chooseInClass">
        <template>
          <div v-if="inClass">
            <div class="vu van-ellipsis">{{ inClass.className }}</div>
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>
    </div>

    <div class="footer">
      <van-button block square round type="primary" @click="submit"> 确定 </van-button>
    </div>
  </div>
</template>

<script>
export default {  
  data() {
    const params = this.$route.params;
    return {
      pageTitle: '批量调班',
      // 调入班级
      inClass: null,
      params: {
        // 学员id
        studentIds: params.studentIds,
        // 校区id
        campusId: params.campusId,
        // 调出班级课价id,
        curriculumId: params.curriculumId,
        // 调出班级id
        classId: params.classId,
        // 调入班级id
        transferClassId: '',
        // 是否超报
        oversold: 0,
      },
    };
  },
  methods: {
    // 选择转入班级
    async chooseInClass() {
      let ret = await app.x3.side.xsClass({
        id: this.params.transferClassId,
        api: this.$api.findClassPageByPriceItemId,
        params: {
          ignoreClassId: this.params.classId,
          ignoreClassStudentId: this.params.studentId,
          campusIds: [this.params.campusId],
          curriculumIds: [this.params.curriculumId],
          classStatus: 0,
          page: {
            pageNum: 1,
            pageSize: 99999,
          },
        },
        config: {
          radio: true,
          must: true,
          enable: true,
        },
        filter: {
        // 是否开启校区筛选
        enableCampusFilter: false,
        // 是否开启老师筛选
        enableTeacherFilter: true,
        // 是否启用班级状态筛选
        enableStatusFilter: false,
        // 隐藏课程筛选
        hidePriceFilter: true,
      },
      });
      console.log(ret);
      if (ret) {
        this.params.transferClassId = ret.id;
        this.inClass = ret;
      }
    },
    async submit() {      
      if (!this.params.transferClassId) {
        this.$toast('请选择调入班级');
        return false;
      }
      this.showLoading();
      let res = await this.$api.transferClassBatch(this.params);
      this.$toast.clear();
      if (res.code === 200) {
        vant.Toast.success('调班成功');
        setTimeout(() => {
          app.vue.$emit('refresh-classStudentList');
          app.vue.$emit('refresh-student-school-record-list');
          this.$router.back();
        }, 300);
        return false;
      } else if (res.code == 790000001) {
        vant.Dialog.confirm({
          title: '提示',
          message: '调入班级剩余名额不足，继续调入将导致班级超员，请确认是否继续？',
        }).then(() => {
          this.params.oversold = 1;
          this.submit();
        });
        return false;
      } else if (res.code == 830000035) {
        let html = `<div style="text-align:left">以下学员调班失败：</div>`
        if (res.data.failInfoList && res.data.failInfoList.length){
          html += res.data.failInfoList.map(item=>{
            return `<div>${item.studentName} &nbsp; ${item.msg}</div>`
          }).join('');
        }
        vant.Dialog.alert({
          title: '提示',
          allowHtml: true,
          message: html,
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow: auto;
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    .van-button {
      height: var(--cl-xs);
    }
  }
}

.cus-cell {
  .van-cell__value {
    .desc {
      color: var(--g6);
    }
    .txt-btn {
      color: var(--tlc);
    }
  }
}

.van-cell {
  .tctil {
    color: var(--g7);
  }
  .van-cell__value {
    color: var(--g5);
  }
  .vu {
    color: var(--g8);
  }
}
</style>